import { useTheme } from "@/src/styles/theme-provider";
import { Add, Minus } from "iconsax-react-nativejs";
import React, { useState } from "react";
import { TextInput, TouchableOpacity, View } from "react-native";

type CapacityCounterProps = Readonly<{
  value: number;
  onChange: (val: number) => void;
  min?: number;
  max?: number;
}>;

const CapacityCounter = ({
  value,
  onChange,
  min = 1,
  max = 9999,
}: CapacityCounterProps) => {
  const { themeVars } = useTheme();
  const [focused, setFocused] = useState(false);
  const [draftText, setDraftText] = useState<string | null>(null);

  const clamp = (num: number) => Math.min(max, Math.max(min, num));

  const handleTextChange = (text: string) => {
    const digitsOnly = text.replace(/[^0-9]/g, "");

    if (digitsOnly === "") {
      setDraftText("");
      return;
    }

    setDraftText(digitsOnly);
    onChange(clamp(Number(digitsOnly)));
  };

  const handleBlur = () => {
    setFocused(false);
    if (draftText === "") {
      onChange(min);
    }
    setDraftText(null);
  };

  const displayValue = draftText !== null ? draftText : String(value);

  return (
    <View className="flex-row items-center gap-4">
      <TouchableOpacity
        onPress={() => onChange(clamp(value - 1))}
        activeOpacity={0.7}
        className="w-6 h-6 rounded-full border border-primary items-center justify-center hover:bg-ash-3"
      >
        <Minus
          size={16}
          color={themeVars["--color-primary-default"] as string}
        ></Minus>
      </TouchableOpacity>

      <TextInput
        value={displayValue}
        onChangeText={handleTextChange}
        keyboardType="number-pad"
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        className={`text-base font-semibold text-ash-2 w-[40px] text-center focus:outline-none border-b ${
          focused ? "border-primary border" : "border-ash-1"
        }`}
      />

      <TouchableOpacity
        onPress={() => onChange(clamp(value + 1))}
        activeOpacity={0.7}
        className="w-6 h-6 rounded-full border border-primary items-center justify-center hover:bg-ash-3"
      >
        <Add
          size={16}
          color={themeVars["--color-primary-default"] as string}
        ></Add>
      </TouchableOpacity>
    </View>
  );
};

export default CapacityCounter;
